import { useIntl } from "@umijs/max";
import { FloatButton, Form, Input, message, Modal, Select } from "antd";
import { MessageSquare } from "lucide-react";
import React, { useState } from "react";
import { submitFeedback } from "@/services/ourwork/feedback";

const FeedbackWidget: React.FC = () => {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleOpen = () => {
    form.resetFields();
    setOpen(true);
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      await submitFeedback({
        ...values,
        pageUrl: window.location.href,
        browserInfo: navigator.userAgent,
      });
      message.success(
        intl.formatMessage({
          id: "feedback.submitSuccess",
          defaultMessage: "フィードバックを送信しました",
        })
      );
      setOpen(false);
    } catch (err: any) {
      if (err?.errorFields) return;
      message.error(
        intl.formatMessage({
          id: "feedback.submitError",
          defaultMessage: "送信に失敗しました",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const categoryOptions = [
    {
      value: "SUGGESTION",
      label: intl.formatMessage({
        id: "feedback.category.suggestion",
        defaultMessage: "ご意見・ご要望",
      }),
    },
    {
      value: "BUG",
      label: intl.formatMessage({
        id: "feedback.category.bug",
        defaultMessage: "バグ報告",
      }),
    },
    {
      value: "FEATURE",
      label: intl.formatMessage({
        id: "feedback.category.feature",
        defaultMessage: "機能リクエスト",
      }),
    },
  ];

  return (
    <>
      <FloatButton
        icon={<MessageSquare size={20} />}
        tooltip={intl.formatMessage({
          id: "feedback.tooltip",
          defaultMessage: "フィードバック",
        })}
        onClick={handleOpen}
      />

      <Modal
        title={intl.formatMessage({
          id: "feedback.title",
          defaultMessage: "フィードバック",
        })}
        open={open}
        onCancel={() => setOpen(false)}
        onOk={handleSubmit}
        confirmLoading={loading}
        okText={intl.formatMessage({
          id: "feedback.submit",
          defaultMessage: "送信",
        })}
        width={520}
        destroyOnHidden
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{ category: "SUGGESTION" }}
        >
          <Form.Item
            name="category"
            label={intl.formatMessage({
              id: "feedback.category",
              defaultMessage: "カテゴリ",
            })}
            rules={[{ required: true }]}
          >
            <Select options={categoryOptions} />
          </Form.Item>
          <Form.Item
            name="content"
            label={intl.formatMessage({
              id: "feedback.content",
              defaultMessage: "内容",
            })}
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "feedback.contentRequired",
                  defaultMessage: "内容を入力してください",
                }),
              },
            ]}
          >
            <Input.TextArea rows={4} maxLength={2000} showCount />
          </Form.Item>
          <Form.Item
            name="contactEmail"
            label={intl.formatMessage({
              id: "feedback.contactEmail",
              defaultMessage: "連絡先メール（任意）",
            })}
            rules={[
              {
                type: "email",
                message: intl.formatMessage({
                  id: "feedback.emailInvalid",
                  defaultMessage: "メールアドレスの形式が正しくありません",
                }),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default FeedbackWidget;
